import * as NUMBER from 'constant/number'
import { CATEGORY_RESET, SUB_CATEGORY_RESET } from 'constant/form-item-names'
import React, { useEffect } from 'react'
import { Row, Col, Form } from 'antd'
import Editor from 'view/component/editor'
import PropTypes from 'prop-types'
import TitleInput from 'view/component/form-items/title-input'
import ShortDescriptionInput from 'view/component/form-items/short-description-input'
import OrganisationSelect from 'view/component/form-items/article-org-select'
import CategorySelect from 'view/component/form-items/category-select'
import SubCategorySelect from 'view/component/form-items/sub-category-select'
import UpdateFrequencySelect from 'view/component/form-items/update-frequency-select'
import AssociatedDataSet from 'view/component/form-items/associated-dataset'
import PublishedSelect from 'view/component/form-items/published-select'
import Upload from 'view/component/form-items/upload'
import UserTypeSelect from 'view/component/form-items/article-user-type-select'

const defaultFormValues = { published: false }

const ArticleForm = ({ article = defaultFormValues, form }) => {
  useEffect(() => {
    form.setFieldsValue(article)
  }, [article])

  const handleCategorySelect = () => form.resetFields(CATEGORY_RESET)
  const handleSubCategorySelect = () => form.resetFields(SUB_CATEGORY_RESET)

  return (
    <Row gutter={NUMBER.FIFTY}>
      <Col xl={NUMBER.EIGHT}>
        <Form
          form={form}
          layout='vertical'
        >
          <TitleInput />
          <ShortDescriptionInput />
          <AssociatedDataSet />
          <CategorySelect handleChange={handleCategorySelect} />
          <SubCategorySelect handleChange={handleSubCategorySelect} />
          <OrganisationSelect />
          <UserTypeSelect />
          <UpdateFrequencySelect />
          <PublishedSelect />
          <Upload fileName={article.image_name} />
        </Form>
      </Col>
      <Col xl={NUMBER.SIXTEEN}>
        <Editor form={form} />
      </Col>
    </Row>
  )
}

ArticleForm.propTypes = {
  article: PropTypes.object,
  form: PropTypes.object
}

export default ArticleForm
